module.exports = __webpack_public_path__ + "src/images/products/sneakerhead/67_62265 Hand Brush Color Treatment Hooded Sweatshirt.png";